/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getTransactionMeta, saveTransactionMeta } from '../transactionMeta';
export class FlowMonitor {
    constructor(authClient) {
        this.authClient = authClient;
    }
    // detect in-memory loop
    loopDetected(remediator) {
        if (!this.previousRemediator) {
            this.previousRemediator = remediator;
            return false;
        }
        if (this.previousRemediator.getName() === remediator.getName()) {
            return true;
        }
        this.previousRemediator = remediator;
        return false;
    }
    isRemediatorCandidate(
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    remediator, remediations, values) {
        const remediatorName = remediator.getName();
        if (!values.skip && remediatorName === 'skip') {
            return false;
        }
        if (values.skip && remediatorName !== 'skip') {
            return false;
        }
        return true;
    }
    trackRemediations(name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meta = yield getTransactionMeta(this.authClient);
            const remediations = meta.remediations || [];
            meta = Object.assign(Object.assign({}, meta), { remediations: [...remediations, name] });
            saveTransactionMeta(this.authClient, meta);
        });
    }
    isFinished() {
        return Promise.resolve(true);
    }
}
